<div class="change-tracking">
  <div class="box-header" [formGroup]="filtersForm">
    <h3 *ngIf="!hideTitle">{{ 'CHANGE_TRACKING.change_tracking' | translate }}</h3>
    <div *ngIf="!hideTabs" class="nav nav-tabs">
      <div *ngFor="let tab of trackingSources"
           class="nav-item text-center"
           (click)="changeTrackingSource(tab.id)"
           [tooltip]="tab.tooltip | translate"
           placement="bottom">
        <a class="nav-link block text-ellipsis"
           [ngClass]="{'active': filtersForm.get('trackingSource').value === tab.id}">
          <span>{{ tab.transId | translate }}</span>
        </a>
      </div>
    </div>
    <button
      (click)="resetFilters()"
      [disabled]="!isFiltering()"
      class="btn btn-sm md-flat text-primary l-h m-a-0 m-r-xs m-l-xs clear-filters-btn"
      test-id="btnCleanFilters">
      {{ 'COMMON.clearFilters' | translate }}
    </button>
  </div>

  <div class="box-body">
    <gp-table class="table table-striped" (sortChange)="onSortKeyChange($event)" [fixedLayout]="false">
      <thead class="table-header-sticky-top">
      <tr>
        <th scope="col" gp-table-column sort-key="updatedate" default-sort="asc" class="text-muted text-center"
            [ngClass]="showSdcColumns ? 'column-width-16' : 'column-width-25'">
          {{ 'CHANGE_TRACKING.date' | translate }}
        </th>
        <th scope="col" gp-table-column sort-key="author" class="text-muted text-center"
            [ngClass]="showSdcColumns ? 'column-width-7' : 'column-width-25'">
          {{ 'CHANGE_TRACKING.author' | translate }}
        </th>
        <th scope="col" gp-table-column sort-key="item" class="text-muted text-center"
            [ngClass]="showSdcColumns ? 'column-width-12' : 'column-width-25'">
          {{ 'CHANGE_TRACKING.type' | translate }}
        </th>
        <th scope="col" gp-table-column  sort-key="groupZoneName" class="text-muted text-center"
            [ngClass]="showSdcColumns ? 'column-width-14' : 'column-width-25'">
          {{ 'CHANGE_TRACKING.changes' | translate }}
        </th>

        <th scope="col" *ngIf="showSdcColumns" gp-roles [userRoles]="['SDC_CALL_DETAILS']"
            gp-table-column class="column-width-18 text-muted text-center">
          {{ 'CHANGE_TRACKING.syncCall' | translate }}
        </th>
        <th scope="col" *ngIf="showSdcColumns" gp-roles [userRoles]="['SDC_CALL_DETAILS']"
            gp-table-column class="column-width-10 text-muted text-center">
          {{ 'CHANGE_TRACKING.syncStatus' | translate }}
        </th>
        <th scope="col" *ngIf="showSdcColumns" gp-roles [userRoles]="['SDC_CALL_DETAILS']"
            gp-table-column class="column-width-20 text-muted text-center">
          {{ 'CHANGE_TRACKING.syncMessage' | translate }}
        </th>
      </tr>

      <tr class="filters" [formGroup]="filtersForm">
        <td>
          <datepicker-input formControlName="date"></datepicker-input>
        </td>
        <td>
          <input formControlName="author" type="text"
                 class="form-control b-a form-group-sm search-field"
                 placeholder="{{ 'NAVBAR.search' | translate }}">
        </td>
        <td>
          <gp-tree-multi-select #itemFilterComponent
                                [items]="itemTree"
                                [config]="treeConfig"
                                [isSorted]="true"
                                (selectedChange)="onItemSelected($event)">
          </gp-tree-multi-select>
        </td>
        <td>
          <input formControlName="groupZoneName" type="text"
                 class="form-control b-a form-group-sm search-field"
                 placeholder="{{ 'NAVBAR.search' | translate }}">
        </td>
        <td *ngIf="showSdcColumns" colspan="3"></td>
      </tr>
      </thead>

      <tbody>
      <tr *ngIf="loading">
        <td [attr.colspan]="showSdcColumns ? 7 : 4" class="text-center p-t-lg p-b-lg">
          <i class="fa fa-light fa-spinner fa-spin"></i>
        </td>
      </tr>

      <ng-container *ngFor="let log of logs">
        <tr>
          <td class="text-center">
            <i class="pointer caret fa fa-light fa-fw m-r-xs"
               [ngClass]="log.expanded ? 'fa-caret-down' : 'fa-caret-right'"
               (click)="log.expanded = !log.expanded"></i>
            {{ log.updateDate | gpDate:{ withTime: true, timezone: timezone } }}
          </td>

          <td class="text-center text-wrap">{{ log.author }}</td>
          <td class="text-center" [ngSwitch]="log.item">
            <ng-container *ngSwitchCase="'EMP_DATA'">
              {{ 'CHANGE_TRACKING.data' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'CONTRACT_FLATTEN'">
              {{ 'CHANGE_TRACKING.inheritedData' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'EMP_VARIABLE'">
              {{ 'CHANGE_TRACKING.variable' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'PEOPLE_TREE_NODE'">
              {{ 'CHANGE_TRACKING.peopleTree' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'EMP_ABSENCE'">
              {{ 'CHANGE_TRACKING.absence' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'REP_DATA'">
              {{ 'CHANGE_TRACKING.repData' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'REP_ENTITY'">
              {{ 'COMMON.entity' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="'CLI_EMP_DATA'">
              {{ 'CHANGE_TRACKING.EmployeeData' | translate }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ log.item }}
            </ng-container>
          </td>

          <td class="text-center text-wrap">
            {{ log.changes.groupNames }}<br>{{ log.itemParentDescription }}
          </td>
          <td *ngIf="showSdcColumns" gp-roles [userRoles]="['SDC_CALL_DETAILS']" class="text-center">
            {{ log.sdcEventLogDetails?.eventType }}
          </td>
          <td *ngIf="showSdcColumns" gp-roles [userRoles]="['SDC_CALL_DETAILS']" class="text-center">
            <span *ngIf="log.sdcEventLogDetails?.status as sdcStatus"
                  class="event-status" [ngClass]="'event-status-' + sdcStatus">{{ sdcStatus }}</span>
          </td>
          <td *ngIf="showSdcColumns" gp-roles [userRoles]="['SDC_CALL_DETAILS']" class="text-center">
            <textarea readonly class="message-text-area">{{ log.sdcEventLogDetails?.message }}</textarea>
          </td>
        </tr>

        <tr *ngIf="log.expanded">
          <td colspan="100%">
            <div *ngFor="let group of log.changes" class="details-group m-t-sm">
              <div class="row text-muted small">
                <div class="col-xs-4 text-right">{{ 'CHANGE_TRACKING.field' | translate }}</div>
                <div class="col-xs-4 text-center">{{ 'CHANGE_TRACKING.before' | translate }}</div>
                <div class="col-xs-4 text-center">{{ 'CHANGE_TRACKING.after' | translate }}</div>
              </div>
              <div *ngFor="let prop of group.props | keys">
                <div *ngIf="!(isValueConsideredAsEmpty(group.before[prop]) && isValueConsideredAsEmpty(group.after[prop])) &&
                               group.before[prop] !== group.after[prop]"
                     class="row">
                  <div class="col-xs-4 text-right">{{ prop | translate }}</div>
                  <div class="col-xs-4 text-center text-wrap" [innerHTML]="getDisplayValue(group.before[prop])"></div>
                  <div class="col-xs-4 text-center text-wrap" [innerHTML]="getDisplayValue(group.after[prop])"></div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>

      <!-- No data message -->
      <tr *ngIf="!loading && logs.length === 0">
        <td [attr.colspan]="showSdcColumns ? 7 : 4">
          <gp-illustrated-message [text]="noChangeMessage" [width]="'65%'"></gp-illustrated-message>
        </td>
      </tr>
      </tbody>
    </gp-table>
  </div>

  <gp-table-pagination
    [pagination]="pagination"
    [text]="'CHANGE_TRACKING.showing___of_changes'">
  </gp-table-pagination>
</div>
